import styled from '@emotion/styled';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const Image = styled.img`
	width: 100%;
	height: 500px;
	object-fit: cover;
`;

export default function MapBlockZeta({ street }: { street: string }) {
	return (
		<Section id="map">
			<Image src={street} />
		</Section>
	);
}
